import { AfterViewInit, Component, ElementRef, ViewChild } from '@angular/core';
import { BoFormsModule } from '@bo/ng-forms';
import { NgClass } from '@angular/common';
import { FieldComponent } from '../form-field/form-field.component';
import { countAddedSpaces, formatIdNumberValue, getDateOfBirthFromSaIdNumber } from '../../../utils/form-helpers';

@Component({
  selector: 'app-id-field',
  imports: [BoFormsModule, NgClass],
  templateUrl: './id-field.component.html',
})
export class IDFieldComponent extends FieldComponent implements AfterViewInit {
  @ViewChild('inputElement', { static: false }) protected override inputElement?: ElementRef<HTMLInputElement>;
  private formattingInProgress = false;

  override ngAfterViewInit() {
    super.ngAfterViewInit();

    // Format the initial value after the view is initialised
    if (this.fieldControl?.value) {
      setTimeout(() => this.formatDisplayOnly(), 0);
    }
  }

  override onInput() {
    this.formatAsIdNumber();
    super.onInput();
  }

  onBlur(): void {
    this.setDateOfBirthFromIdNumber();
  }

  // When the user has entered a South African ID number, derive the date of birth
  // from its first 6 digits (YYMMDD) and populate the date_of_birth field.
  private setDateOfBirthFromIdNumber(): void {
    const parentForm = this.fieldControl?.parent;
    if (!parentForm) return;

    const idNumTypeValue = parentForm.get('idnum_type')?.value;
    const isRsaId = idNumTypeValue === 1 || idNumTypeValue == null;
    if (!isRsaId) return;

    const dateOfBirth = getDateOfBirthFromSaIdNumber(this.fieldControl.value);
    if (!dateOfBirth) return;

    parentForm.get('date_of_birth')?.setValue(dateOfBirth);
  }

  private formatAsIdNumber(): void {
    const input = this.inputElement?.nativeElement;
    if (!input) return;

    // Prevent recursive formatting
    if (this.formattingInProgress) return;
    this.formattingInProgress = true;

    const cursorPos = input.selectionStart || 0;

    // Get raw value (strip spaces)
    const rawValue = input.value.replaceAll(/\s/g, '');

    // Store raw value in form control
    this.fieldControl.setValue(rawValue, { emitEvent: false });

    // Format for display
    input.value = formatIdNumberValue(rawValue);

    // Calculate and restore cursor position
    const addedSpaces = countAddedSpaces(cursorPos);
    const newCursorPos = cursorPos + addedSpaces;

    // Set the cursor position after the format
    setTimeout(() => {
      input.setSelectionRange(newCursorPos, newCursorPos);
      this.formattingInProgress = false;
    }, 0);
  }

  // Format display only (for initial values)
  private formatDisplayOnly(): void {
    const input = this.inputElement?.nativeElement;
    if (!input || !this.fieldControl?.value) return;

    // Format for display without changing the stored value
    input.value = formatIdNumberValue(this.fieldControl.value);
  }
}
